/* eslint-disable */
import { connect } from 'react-redux';
import Chip from '@mui/material/Chip';
// import DownloadIcon from '@mui/icons-material/Download';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import moment from 'moment';
import DatePicker from 'rsuite/DatePicker';
import { EditIcon, Filter, RefreshCcw } from 'lucide-react';
import {
	analyticsAction,
	formActions,
	modalActions,
} from '../../../../Actions';
import { ListTable } from '../../../../Components/ListTable';
import { POItemsModal } from '../../../../Components/Modals/POItemsModal';
import styles from './PurchaseOrderList.module.scss';
// import PurchaseOrderListHeader from './PurchaseOrderListHeader/PurchaseOrderListHeader';
import { VanImageModal } from '../../../../Components/Modals/VanImageModal';
import assetServices from '../../../../Services/AssetServices/asset.services';
import { notificationServices } from '../../../../Services';
import inventoryAnalyticsServices from '../../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal, ProductionPlanModal } from '../../../../Components/Modals';
import BackdropLoader from '../../../../Components/Loaders/BackdropLoader';
import { urls } from '../../../../Constants';
import {
	addCommas,
	classes,
	filtersInfoChip,
	handleImagePreview,
	handleOrderStatus,
	handleResponseStreamDownload,
	useSearch,
} from '../../../../Helpers';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import ExportFiltersDrawer from '@/Components/Drawers/ExportFiltersDrawer/ExportFiltersDrawer';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';
import drawerActions from '@/Actions/drawer.actions';
import DebitCreditListDrawer from '@/Components/Drawers/DebitCreditListDrawer/DebitCreditListDrawer';
import { Button } from '@/Components/ui/button';
import DatePickerModal from './DatePickerModal';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import AssetTransitModal from '@/Components/Modals/AssetTransitModal/AssetTransitModal';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalSearch from '@/Components/globalSearch/search';
import { Tooltip } from '@mui/material';
import { SelectPicker } from 'rsuite';
import shiftServices from '@/Services/shift.service';

const SPECIAL_COLUMNS = [
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client PO ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},

	{
		title: 'Received Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Receive date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Shift Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'PO Id': 'id',
	'Client PO ID': 'clientPoId',
	'Order Date': 'createdAt',
	'Invoice Date': 'invoicedAt',
	'Received Date': 'receivedAt',
	'Expected Dispatch Date': 'id',
	'Expected Receive date': 'id',
	'Deliver To': 'storeName',
	'Shift Name': 'shiftName',
	BASE: 'fromStoreName',
	'Van Temp': 'receivingTemp',
	'Temp Meter Image': 'receivingTempImage',
	// 'Transit Van Temp': 'receivingTemp',
	'Order Status': 'orderStatus',
	'Generation Type': 'id',
	Vendor: 'vendorName',
	Buyer: 'vendorName',
	'Vehicle No': 'orderImages',
	'Vehicle Image at Dispatch': 'orderImages',
	'Vehicle Image at Receiving': 'orderImages',
};

const orderStatus = [
	'PENDING',
	'DISPATCH',
	'TRANSIT',
	'UNLOADING',
	'VERIFICATION',
	'FULFILLED',
	'CANCELLED',
	'ABANDONED',
];

const dateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Expected Dispatch Date',
		value: 'dispatchDate',
	},
	{
		label: 'Expected receive date',
		value: 'scheduled',
	},
	{
		label: 'Invoice Date',
		value: 'invoiced',
	},
	{
		label: 'Received Date',
		value: 'received',
	},
];

function InternalSalesOrder(props) {
	const {
		data,
		type,
		toggleModal,
		toggleVanImageModal,
		toggleAlert,
		toggleProductionPlanModal,
		navState,
		stores,
		fetchPurchaseOrderList,
		toggleDebitCreditListDrawer,
		toggleAssetTransit,
		toggleFiltersDrawer,
	} = props;

	const isInternalSales = type === 'internalSales';
	const [update, setUpdate] = useState(-1);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const navRequisites = navState?.[urls.SALES_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [datePickerModalState, setDatePickerModalState] = useState({
		show: false,
		heading: '',
		currentPo: null,
	});
	const [productionPlanLoading, setProductionPlanLoading] = useState(false);
	const exportFilters = useRef({});
	const [search, setSearch] = useState({});
	const [filterValue, setFilterValue] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	// Orders opened from a Distribution grid cell (D&R Time "view orders" icon): ?poIds=[...].
	// Read once when the page opens and kept here - the filter drawer drops keys it does not know.
	// While set, the list shows only these orders (backend poIds filter skips date / store);
	// "Clear" goes back to the drawer's filters.
	const [linkedPoIds, setLinkedPoIds] = useState(() => {
		try {
			const ids = JSON.parse(new URLSearchParams(window.location.search).get('poIds') || 'null');
			return Array.isArray(ids) && ids.length ? ids.map(Number).filter(Boolean) : null;
		} catch (e) {
			return null;
		}
	});
	const linkedPoIdsRef = useRef(linkedPoIds);
	linkedPoIdsRef.current = linkedPoIds;
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict = {} } = userConfig || {};
	const roles = Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('CXO Office') || Object?.values(userRolesDict)?.includes('Procurement');
	// Shift edit — same rules as Purchase Order List
	const isInternal =
		Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') ||
		Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const configAdminRole = Object?.values?.(userRolesDict ?? {}).includes(
		'Config Admin'
	);

	const [shiftEditState, setShiftEditState] = useState({
		show: false,
		item: null,
		options: [],
		loading: false,
		selected: null,
	});

	const handleShiftEditOpen = useCallback(async (item) => {
		setShiftEditState({
			show: true,
			item,
			options: [],
			loading: true,
			selected: item?.shiftId ?? null,
		});
		try {
			let response;
			if (item?.toProcessId) {
				response = await shiftServices.listProcessShifts({
					data: {
						date: moment(new Date()).format('YYYY-MM-DD'),
						store: item?.fromStore,
						processIds: [item?.toProcessId],
					},
				});
			} else {
				response = await inventoryAnalyticsServices?.fetchShifts({
					params: {
						storeId: item?.fromStore,
					},
				});
			}
			if (response?.statusCode === 200) {
				const options =
					response?.data?.map((s) => ({
						label: s?.shiftName ?? s?.name,
						value: s?.id,
					})) ?? [];
				setShiftEditState((prev) => ({
					...prev,
					options,
					loading: false,
				}));
			} else {
				setShiftEditState((prev) => ({ ...prev, loading: false }));
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Failed to fetch shifts',
				});
			}
		} catch (error) {
			setShiftEditState((prev) => ({ ...prev, loading: false }));
			notificationServices.generateNotification({
				type: 'error',
				message: 'Failed to fetch shifts',
			});
		}
	}, []);

	const handleShiftEditClose = () => {
		setShiftEditState({
			show: false,
			item: null,
			options: [],
			loading: false,
			selected: null,
		});
	};

	const handleShiftEditSave = async () => {
		const { item, selected } = shiftEditState;
		if (!selected) {
			notificationServices.generateNotification({
				type: 'warning',
				message: 'Please select a shift',
			});
			return;
		}
		if (selected === item?.shiftId) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Shift is already same',
			});
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Updating Shift',
		});
		try {
			const response = await inventoryAnalyticsServices?.editVendorPO({
				params: {
					poId: item?.id,
				},
				data: {
					shiftId: selected,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
				setFilters((prev) => {
					return {
						...prev,
						blink: !prev?.blink,
					};
				});
				setTimeout(() => {
					notificationServices.generateNotification({
						type: 'wave',
						message: 'Press find again to get latest updates',
						config: {
							id: notificationId,
						},
					});
				}, 1500);
				handleShiftEditClose();
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Failed to update shift',
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				},
			});
		}
	};


	const handleDatePickerModalSetDate = useCallback(async (date, item) => {
		if (
			moment(item?.scheduledAt, 'YYYY-MM-DD HH:mm:ss').format(
				'YYYY-MM-DD'
			) === moment(date).format('YYYY-MM-DD')
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Date is already same',
			});
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Updating Date',
		});
		try {
			const response = await inventoryAnalyticsServices?.editVendorPO({
				params: {
					poId: item?.id,
				},
				data: {
					scheduled: moment(date).format('MM/DD/YYYY'),
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
				setFilters((prev) => {
					return {
						...prev,
						blink: !prev?.blink,
					};
				});
				setTimeout(() => {
					notificationServices.generateNotification({
						type: 'wave',
						message: 'Press find again to get latest updates',
						config: {
							id: notificationId,
						},
					});
				}, 1500);
				setDatePickerModalState({
					show: false,
					heading: '',
					currentPo: null,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				},
			});
		}
	}, []);

	const handleDatePickerModalOpen = useCallback((item) => {
		setDatePickerModalState({
			show: true,
			heading: `Expected Receive date for ${item?.clientPoId}`,
			currentPo: item,
		});
	}, []);

	useEffect(() => {
		exportFilters.current = {
			...exportFilters.current,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,
		};
	}, [navSelectedStore?.value?.id]);

	const [filters, setFilters] = useState({
		storeId: null,
		dateRange: {
			startDate: new Date(),
			endDate: new Date(),
		},
	});

	const storeIdMap = useMemo(() => {
		const map = {};
		stores?.forEach((store) => {
			map[store?.id] = store;
		});
		return map;
	}, [stores]);

	useEffect(() => {
		if (navSelectedStore?.value?.id) {
			setFilters((prev) => {
				return {
					...prev,
					fulfilledBy:
						navSelectedStore?.value?.id === -999
							? null
							: navSelectedStore?.value?.id,
				};
			});
			// setUpdate((prev) => {
			// 	return prev + 1;
			// });
		}
	}, [navSelectedStore?.value?.id, type]);

	const handlePoStatus = (id, status) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Order ${id || ''}`.trim(),
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status,
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	// const handleDownloadGRN = (downloadLink) => {
	// window.open(downloadLink);
	// };

	const handleViewClick = (item) => {
		toggleModal(true, {
			heading: `PO Items of #${item?.id}`,
			...item,
			showPdf: item?.poURL,
			showTotal: true,
			showPoDetails: true,
			width: '80%',
			height: '90%',
			transactionData: {
				'Order ID': item?.clientPoId,

				'Deliver To Store': item?.storeName,
				'Deliver From Store': item?.fromStoreName,
				'Deliver To Store GSTIN': item?.storeGstin,
				'Deliver From Store GSTIN': item?.fromStoreGstin,
				'Payment Term': item?.jsonData?.paymentTerm,
			},
			excludedColumns: isInternalSales
				? [
					'PO Id',
					'From Process',
					'Quantity',
					'Returned Quantity',
					'Fulfilled',
					'Returned',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
					'Standard PO Qty',
				]
				: [
					'Packaged',
					'Dispatched',
					'Returned Quantity',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
					'Standard PO Qty',
				],
		});
	};
	const viewMoreOptionsList = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		'View Debit/Credit Note': (item, cb) => {
			toggleDebitCreditListDrawer(true, {
				poId: item?.id,
				heading: `Debit/Credit Notes of ${item?.clientPoId ?? item?.id
					}`,
			});
			cb();
		},
		'View Assets': async (item, cb) => {
			try {
				const res = await assetServices?.fetchAssetTransitFlow({
					req: {
						params: {
							id: Number(item?.id),
						},
					},
				});
				if (res?.statusCode === 200) {
					const response = res?.data;
					if (response.length > 0) {
						toggleAssetTransit(true, {
							heading: `PoId : ${item?.id}`,
							data: response,
						});
					} else {
						notificationServices?.generateNotification({
							type: 'warning',
							message: 'No assets are packaged yet in this PO',
						});
					}
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
				});
			}
		},
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [
			'Id',
			'Client PO Id',
			'Expected Receive date',
			'Order status',
			'Raised by',
			'Fulfilled by',
		];
		const downloadBtn = document.createElement('a');

		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);


	const isLatLongSameForPOStore = (item) => {
		const fromStoreLatitude = storeIdMap[item?.fromStore]?.latitude;
		const fromStoreLongitude = storeIdMap[item?.fromStore]?.longitude;

		const toStoreLatitude = storeIdMap[item?.storeId]?.latitude;
		const toStoreLongitude = storeIdMap[item?.storeId]?.longitude;

		return (
			fromStoreLatitude === toStoreLatitude &&
			fromStoreLongitude === toStoreLongitude
		);
	};

	const statusStyles = {
		DISPATCH: 'rgba(255, 217, 0, 0.5)',      // yellow
		TRANSIT: 'rgba(0, 128, 128, 0.5)',       // teal
		UNLOADING: 'rgba(255, 208, 0, 0.5)',     // orange-ish
		VERIFICATION: 'rgba(30, 255, 0, 0.25)',  // green
		FULFILLED: 'rgba(0, 128, 0, 0.5)',       // green
		CLOSED: '#bbf7d0',          // green
		CANCELLED: '#fecaca',       // red
		ABANDONED: '#64748b',       // darker red
	};

	const textColors = {
		DISPATCH: '#b38600',
		TRANSIT: '#004d4d',
		UNLOADING: '#b37700',
		VERIFICATION: '#1b7300',
		FULFILLED: '#006600',
		CLOSED: '#166534',
		CANCELLED: '#991b1b',
		ABANDONED: '#cbd5e1',
	};

	function getStatusStyle(status) {
		return {
			background: statusStyles[status] || 'transparent',
			color: textColors[status] || '#000',
			padding: '6px 8px',
			borderRadius: '4px',
			fontSize: '12px',
			width: '10rem',
		};
	}

	const SPECIAL_ITEMS = {
		'PO Id': (_, item) => {
			return <p className='text-[12px] text-left'>{item}</p>
		},
		'Client PO ID': (id, clientPoId) => {
			if (!clientPoId) {
				return <p className='text-[12px] text-left text-nowrap'>-</p>;
			}
			const rowItem = data?.find((poItem) => poItem?.id === id);
			return (
				<p
					role='button'
					tabIndex={0}
					className='text-[12px] text-left text-nowrap cursor-pointer'
					style={{ color: '#2563eb', textDecoration: 'underline' }}
					onClick={(e) => {
						e.stopPropagation();
						if (rowItem) handleViewClick(rowItem);
					}}
				>
					{clientPoId}
				</p>
			);
		},
		'Order Date': (_, item) => {
			return <p className='text-[12px] text-left'>{moment(item).format('Do MMMM YY')}</p>
		},
		'Received Date': (_, item) => {
			return item && <p className='text-[12px] text-left'>{moment(item).format('Do MMMM YY')}</p>
		},
		'Expected Receive date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const status = [
				'CANCELLED',
				'CLOSED',
				'ABANDONED',
				'UNLOADING',
				'VERIFICATION',
			];
			if (
				levels.includes(level) &&
				roles &&
				!status.includes(item?.orderStatus)
			) {
				return (
					<div
						className='flex  items-center justify-between border border-gray-200 p-2 cursor-pointer hover:bg-gray-50 rounded-md transition-colors'
						onClick={(e) => {
							e.stopPropagation();
							handleDatePickerModalOpen(item);
						}}
					>
						<span className='text-gray-700 text-[12px] text-nowrap'>
							{item?.scheduledAt?.split(' ')[0] ?? '-'}
						</span>
						<EditIcon className='text-gray-500 hover:text-gray-700' />
					</div>
				);
			} else {
				return (
					<span className='text-gray-700 block text-[12px] text-start text-nowrap'>
						{item?.scheduledAt?.split(' ')[0] ?? '-'}
					</span>
				);
			}
		},
		'Deliver To': (_, item) => {
			return <p className='text-[12px] text-start text-nowrap'>{item}</p>;
		},
		'Deliver From': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<p
					className='text-[12px] text-left text-nowrap'
				>
					{item?.fromStoreName ?? '-'}
				</p>
			);
		},
		// Columns here are ListTable `actions`, which call special(id, value) — so look the PO up
		// by id (like 'Deliver From') instead of treating the second argument as the row.
		'Shift Name': (itemId, value) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			const closedStatuses = [
				'CANCELLED',
				'CLOSED',
				'ABANDONED',
				'UNLOADING',
				'VERIFICATION',
			];
			if (
				levels.includes(level) &&
				(isInternal || configAdminRole) &&
				!closedStatuses.includes(item?.orderStatus) &&
				!item?.jsonData?.generatedPPId
			) {
				return (
					<div
						className='flex w-36 items-center justify-between border border-gray-200 p-2 cursor-pointer hover:bg-gray-50 rounded-md transition-colors'
						onClick={(e) => {
							e.stopPropagation();
							handleShiftEditOpen(item);
						}}
					>
						<span className='text-gray-700 text-[12px]'>
							{item?.shiftName ?? '-'}
						</span>
						<EditIcon className='text-gray-500 hover:text-gray-700' />
					</div>
				);
			}
			return (
				<p className='text-[12px] text-start text-nowrap'>
					{item?.shiftName ?? value ?? '-'}
				</p>
			);
		},
		'Order Status': (_, item) => {
			return <div style={getStatusStyle(item)}>{handleOrderStatus(item)}</div>
		},
	};

	const handleEditSubmit = async (editedValues) => {
		try {
			const response = await assetServices.editAssetTemp({
				data: editedValues,
				params: {
					type: 'PO',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? error?.message,
			});
		}
	};

	const handleFilterDrawerOpen = () => {
		toggleFiltersDrawer(true, {
			handleDataExport: (filtersState) =>
				handleExport({
					...exportFilters.current,
					dateRangeFilter: {
						dateType: filtersState?.timeType?.value,
						from: moment(
							filtersState?.dateRange?.from
						).format('YYYY-MM-DD'),
						to: moment(
							filtersState?.dateRange?.to
						).format('YYYY-MM-DD'),
					},
					variantIds: [...new Set(filtersState?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
					exportType: filtersState?.exportType,
				}),
		});
	}

	const generateProductionPlan = async (idsList) => {
		const isDispatchSelectd = filters?.dateRange?.dateType == "dispatchDate";
		if (!isDispatchSelectd) {
			notificationServices.generateNotification({
				type: 'error',
				message: "Please select Expected dispatch date, and Search POs",
			});
			handleFilterDrawerOpen();
			return;
		}
		const req = {
			data: {
				poIds: idsList,
				storeId: navSelectedStore?.value?.id,
				date: filters?.dateRange?.startDate,
			},
		};
		setProductionPlanLoading(true);
		try {
			const response =
				await inventoryAnalyticsServices.fetchProductionPlan(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				toggleProductionPlanModal(true, {
					idsList,
					storeId: navSelectedStore?.value?.id,
					date: filters?.dateRange?.startDate,
					listData: response?.data,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setProductionPlanLoading(false);
		}
	};
	const moreOptionsList = {
		'E-Way bill': (po, cb) => {
			if (!orderStatus?.slice(2, -1).includes(po?.orderStatus)) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No invoice has been generated yet for this order',
				});
				return;
			}
			const urlType = 'EWAYBILL';
			const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&type=${urlType}`;
			history.push(url);
			cb();
		},
		'E-Invoice': (po, cb) => {
			if (!orderStatus?.slice(2, -1).includes(po?.orderStatus)) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No invoice has been generated yet for this order',
				});
				return;
			}
			const urlType = 'INVOICE';
			const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${po?.id}&type=${urlType}`;
			history.push(url);
			cb();
		},
	};

	const handleFetchPurchaseOrderList = (finderFilters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		const dateRange = {
			startDate: moment(finderFilters?.dateRange?.from).format(
				'YYYY-MM-DD'
			),
			endDate: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
			dateType: finderFilters?.timeType?.value,
		};
		setFilterValue(finderFilters);
		setFilters((prev) => {
			return {
				...prev,
				dateRange,
				fulfilledBy:
					finderFilters?.multiStore?.id?.length > 0
						? finderFilters.multiStore.id
						: finderFilters?.store?.id,
			};
		});
		const req = {
			data: {
				filters: {
					storeId:
						finderFilters?.multiStore?.id?.length > 0
							? finderFilters.multiStore.id
							: (finderFilters?.store?.id === -999
								? null
								: finderFilters?.store?.id),
					fromStoreId:
						finderFilters?.deliverFrom?.id === -999
							? null
							: finderFilters?.deliverFrom?.id,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
						dateType: dateRange.dateType,
					},
					status: finderFilters?.status,
					// 'All' carries a null id, so shiftId is left out of the payload
					// entirely and the backend does not filter on shift.
					...(finderFilters?.shift?.id
						? { shiftId: finderFilters.shift.id }
						: null),
					variantIds: [...new Set(finderFilters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
					orderType: 'sales/purchase',
					userOrderType: 'sales',
					...(linkedPoIdsRef.current ? { poIds: linkedPoIdsRef.current } : null),
					...(isRefresh
						? null
						: search?.value === 'poId'
							? { poId: Number(search?.searchValue) }
							: { clientPoId: search?.searchValue }),
				},
			},
		};
		exportFilters.current = req.data.filters;
		fetchPurchaseOrderList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'PO_LIST',
			req,
		});
	};

	// eslint-disable-next-line no-unused-vars
	const combinePO = async () => {
		const from = moment(filters?.dateRange?.startDate).format('YYYY-MM-DD');
		const to = moment(filters?.dateRange?.endDate).format('YYYY-MM-DD');
		try {
			const req = {
				data: {
					storeId: navSelectedStore?.value?.id,
					dateRangeFilter: {
						from,
						to,
					},
				},
			};
			const response =
				await inventoryAnalyticsServices.combinePurchaseOrder({
					req,
				});

			// Check if the Content-Type of the response is 'text/csv'
			const contentType = response?.headers?.get('Content-Type');
			if (contentType && contentType?.includes('text/csv')) {
				const blob = await response.blob(); // Get the response data as a Blob
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = `Combined_PO_${from}-${to}.csv`;
				link.click();
				window.URL.revokeObjectURL(blobUrl);

				notificationServices.generateNotification({
					type: 'success',
					message: 'Combined and Downloaded Successfully',
				});
			} else {
				// Handle the case where the response is not 'text/csv'
				try {
					const errorData = await response.json(); // Try to parse the response as JSON
					const errorMessage = errorData?.errorMessage; // Extract the error message
					notificationServices.generateNotification({
						type: 'error',
						message: errorMessage || 'Some error occurred.',
					});
				} catch (jsonError) {
					// Handle the case where the response is not JSON or doesn't contain an error message
					notificationServices.generateNotification({
						type: 'error',
						message: 'Some error occurred.',
					});
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some Error occurred while combining',
			});
		}
	};


	const handleExport = async (fltersObj) => {
		try {
			setLoading(true);
			const response =
				await orderAnalyticsServices.exportGRNWiseOrderHistory({
					data: {
						filters: fltersObj,
					},
				});
			if (response.status === 200) {
				handleResponseStreamDownload(
					response,
					`INTERNAL_SALES_ORDERS_${fltersObj?.dateRangeFilter?.from}_${fltersObj?.dateRangeFilter?.to}.csv`
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setLoading(false);
		}
	};

	const handleOnUpdate = (finderFilters) => {
		const req = {
			data: {
				filters: {
					storeId:
						finderFilters?.multiStore?.id?.length > 0
							? finderFilters.multiStore.id
							: finderFilters?.store?.id,
					fromStoreId:
						navSelectedStore?.value?.id === -999
							? null
							: navSelectedStore?.value?.id,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
						dateType: finderFilters?.timeType?.value,
					},
					status: finderFilters?.status,
					orderType: 'sales/purchase',
					userOrderType: 'sales',
				},
			},
		};
		exportFilters.current = req.data.filters;
	};

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		deliverFrom: {
			text: 'Deliver From',
			show: true,
		},
		store: {
			text: 'Deliver To',
			show: true,
			multiSelect: true,
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		status: {
			text: 'Status',
			show: true,
		},
		// Options are fetched by ImagesFinder from the backend for the selected Deliver
		// From store; the page only turns the filter on.
		shift: {
			text: 'Shift',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		}
	};

	const dropDownItems = [
		{
			label: 'Client PO ID',
			value: 'clientPoId',
			placeholder: 'Search by Client PO ID',
			getData: true,
		},
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by Po ID',
			getData: true,
		},
	];

	const exportInfo = {
		showDropDown: true,
		showExportBtn: true,
		exportTypes: [
			{
				label: 'Invoice-Item wise Sales Register(Finance[ER-UR])',
				value: 'invoiceItemWiseSales',
			},
			{
				label: 'Invoice-Item wise Sales Register',
				value: 'invoiceItemWiseSales_nonFinance',
			},
			{
				label: 'Item-Wise GRN Fullfilment',
				value: 'itemWiseGrn',
			},
			{
				label: 'Item-Wise Sales Register',
				value: 'itemWiseSales',
			},
		],
	};
	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			handleFetchPurchaseOrderList(filterValue);
		}
	}, [search?.searchValue]);

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			handleFetchPurchaseOrderList();
		}
	};

	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />
			<POItemsModal />
			<DatePickerModal
				show={datePickerModalState?.show}
				heading={datePickerModalState?.heading}
				restrictDateType='before'
				currentPo={datePickerModalState?.currentPo}
				onClose={() => {
					setDatePickerModalState({ show: false, heading: '' });
				}}
				onSubmit={handleDatePickerModalSetDate}
			/>
			{shiftEditState?.show && (
				<div className='fixed inset-0 z-[1300] flex items-center justify-center bg-black/40'>
					<div className='w-[380px] max-w-[92vw] bg-white rounded-xl shadow-xl p-5'>
						<div className='mb-4 font-semibold text-base'>
							{`Shift for ${shiftEditState?.item?.clientPoId ?? ''}`}
						</div>
						<SelectPicker
							data={shiftEditState?.options ?? []}
							value={shiftEditState?.selected}
							onChange={(val) => {
								setShiftEditState((prev) => ({
									...prev,
									selected: val,
								}));
							}}
							placeholder={
								shiftEditState?.loading
									? 'Loading shifts…'
									: 'Select Shift'
							}
							loading={shiftEditState?.loading}
							cleanable={false}
							searchable
							block
							menuClassName='z-[1400]'
						/>
						{!shiftEditState?.loading &&
							(shiftEditState?.options?.length ?? 0) === 0 && (
								<p className='mt-2 text-xs text-red-500'>
									No shifts found for this store.
								</p>
							)}
						<div className='mt-5 flex items-center justify-end gap-2'>
							<Button variant='outline' onClick={handleShiftEditClose}>
								Cancel
							</Button>
							<Button
								className='primary-btn'
								onClick={handleShiftEditSave}
								disabled={shiftEditState?.loading}
							>
								Save
							</Button>
						</div>
					</div>
				</div>
			)}
			<AssetTransitModal />
			<ProductionPlanModal />
			<BackdropLoader isLoading={productionPlanLoading} showProgress />
			<VanImageModal handleEditSubmit={handleEditSubmit} />
			<DebitCreditListDrawer />
			<ImagesFinder
				onSubmit={handleFetchPurchaseOrderList}
				update={update}
				blink={filters?.blink}
				statusList={orderStatus?.map((ele) => {
					if (ele === 'FULFILLED') {
						return {
							id: ele,
							title: 'CLOSED',
						};
					}
					if (ele === 'TRANSIT') {
						return {
							id: ele,
							title: 'IN TRANSIT',
						};
					}
					if (ele === 'DISPATCH') {
						return {
							id: ele,
							title: 'PENDING DISPATCH',
						};
					}
					if (ele === 'UNLOADING') {
						return {
							id: ele,
							title: 'UNLOADING STARTED',
						};
					}
					if (ele === 'VERIFICATION') {
						return {
							id: ele,
							title: 'PENDING VERIFICATION',
						};
					}
					return {
						id: ele,
						title: ele,
					};
				})}
				preventDateRangeCheckbox
				onUpdate={handleOnUpdate}
				timeTypeArray={dateTypeArr}
				orderText
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='p-4 w-full flex flex-col gap-2'>
				<div className='flex justify-between items-center w-full'>
					<span className='font-bold text-[16px]'>Store Sales Order</span>
					{level !== 1 && (
						<Button
							onClick={(e) => {
								let typeId = 1;
								if (isInternalSales) {
									if (
										navSelectedStore?.value?.type?.includes(
											'WAREHOUSE'
										)
									) {
										typeId = 3;
									} else {
										typeId = 2;
									}
								}
								history.push(
									`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=sales&typeId=${typeId}&fromStore=${navSelectedStore?.value?.id}&storeTypes=${navSelectedStore?.storesType}`,
									{
										prevPath:
											location?.pathname + location?.search,
									}
								);
							}}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Create Order
						</Button>
					)}
				</div>
				<div className='flex gap-3 w-full justify-start items-center'>
					<div className='w-[90%]'>
						<GlobalSearch
							dropDownOptions={dropDownItems}
							setSelectedValue={setSearch}
							handleValue={handleCall}
							isRefresh={isRefresh}
						/>
					</div>
					<Tooltip title='Refresh Store Sales Order'>
						<RefreshCcw
							className='size-5 cursor-pointer'
							onClick={(e) => {
								handleFetchPurchaseOrderList(filterValue, true);
							}}
						/>
					</Tooltip>
					<Button
						onClick={(e) => { handleFilterDrawerOpen(); }}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
				{linkedPoIds && (
					<div className='flex items-center gap-3 px-3 py-2 rounded-md border border-blue-300 bg-blue-50 text-[13px] text-blue-900'>
						<span>
							Showing <b>{linkedPoIds.length}</b> order{linkedPoIds.length === 1 ? '' : 's'} from the Distribution grid (date and store filters not applied)
						</span>
						<button
							type='button'
							className='font-semibold underline'
							onClick={() => {
								linkedPoIdsRef.current = null;
								setLinkedPoIds(null);
								handleFetchPurchaseOrderList(filterValue);
							}}
						>
							Clear
						</button>
					</div>
				)}
				<div className='flex w-full justify-between items-baseline'>
					{navSelectedStore?.value?.id &&
						navSelectedStore?.value?.id !== -999 &&
						navSelectedStore?.value?.type === 'BASE' && (
							<Button
								type='button'
								onClick={combinePO}
								className='bg-blue-600'
							>
								COMBINE PO
							</Button>
						)}
					{filtersInfoChip(filtersInfo, filterValue)}
				</div>
			</div>
			<div
				className={styles?.table}
			>
				<ListTable
					hasDateRange
					allowCheckList={
						data?.length > 0 &&
						navSelectedStore?.value?.type === 'BASE' &&
						level !== 1
					}
					colMap={COLMAP}
					data={data?.map((ele) => {
						return {
							...ele,
							onClick: () => history.push({
								pathname: `${urls.EXTENSION}${urls.STORE_SALES_DETAILS}`,
								search: `?poId=${ele?.id}&clientPoId=${ele?.clientPoId}`,
								state: {
									prevPath: location.pathname + location.search,
								},
							}),
						};
					})}
					moreOptionsList={moreOptionsList}
					actions={[...SPECIAL_COLUMNS]}
					special={SPECIAL_ITEMS}
					handleViewClick={handleViewClick}
					generateProductionPlan={generateProductionPlan}
					viewMoreOptionsList={viewMoreOptionsList}
					showBtnContainer={false}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { PO_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const categoriesList = state.form.PRODUCT_CATEGORY.data.LIST;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { userList } = state.auth;
	return {
		data,
		stores,
		navState,
		dateRangeFilter,
		categoriesList,
		subCategoriesList,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
	fetchPurchaseOrderList: analyticsAction.gateway,
	fetchSubCategories: formActions.gateway,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	toggleDebitCreditListDrawer: drawerActions.toggleDebitCreditListDrawer,
	fetchUserList: authActions?.fetchUserList,
	toggleAssetTransit: modalActions.toggleAssetTransit,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternalSalesOrder);
